import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vui-form-actions',
  templateUrl: './form-actions.component.html',
  styleUrls: ['./form-actions.component.scss']
})
export class FormActionsComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }
}
